module.exports = __webpack_public_path__ + "e743816e89dc04bdd704b28a14cb05e1.MP3";